import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Department Service */
const createFeedbackTeam = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.feedback.createFeedbackTeam}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Department Service */
const getAllFeedbackTeams = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.feedback.getAllFeedbackTeams}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  /* Get Department List Service*/
const createFeedback = (params) => {
  const { axiosInstance ,config,source} = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.feedback.createFeedback}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};



  /* Update Department Service */
  const givenFeedback = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.feedback.givenFeedback}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


   /* get Received Feedback On Filter Service */
   const getReceivedFeedbackOnFilter = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.feedback.getReceivedFeedbackOnFilter}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  /* get Received Feedback On Filter Service */
  const getFeedbackDashboardData = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.feedback.getFeedbackDashboardData}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };
export default {
    createFeedbackTeam,
    getAllFeedbackTeams,
    createFeedback,
    givenFeedback,
    getReceivedFeedbackOnFilter,
    getFeedbackDashboardData,
}